
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import AnimatedCounter from '@/components/AnimatedCounter';

const EmailSignupSection = () => {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleEmailSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setIsSubscribed(true);
      console.log('Email subscribed:', email);
    }
  };

  return (
    <section className="container max-w-6xl mx-auto px-4 py-20 text-center">
      <div className="bg-gradient-to-br from-vibrant-orange via-vibrant-orange to-vibrant-orange/90 rounded-3xl p-12 text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-30" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='20' height='20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='white' fill-opacity='0.1'%3E%3Ccircle cx='10' cy='10' r='1'/%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
        
        <div className="relative z-10">
          <h3 className="text-4xl font-bold mb-4">
            Be the First to Know
          </h3>
          <p className="text-xl opacity-90 mb-8 max-w-2xl mx-auto leading-relaxed">
            Join <AnimatedCounter target={500} suffix="+ others" className="font-semibold" /> and be notified when we launch. No spam, just the good stuff.
          </p>
          
          {!isSubscribed ? (
            <form onSubmit={handleEmailSubmit} className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto mb-8">
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="flex-1 bg-white/90 backdrop-blur-sm text-deep-blue border-white/20 rounded-xl py-3 px-4"
                required
              />
              <Button
                type="submit"
                className="bg-white text-vibrant-orange hover:bg-gray-50 rounded-xl px-8 py-3 font-semibold shadow-lg hover:shadow-xl transition-all duration-300 cta-button"
              >
                Join the Waitlist
              </Button>
            </form>
          ) : (
            <div className="mb-8 animate-bounce-in">
              <div className="text-3xl mb-3">🎉</div>
              <p className="text-2xl font-semibold mb-2">You're on the list!</p>
              <p className="text-lg opacity-90">We'll notify you as soon as we launch.</p>
            </div>
          )}
          
          <div className="flex items-center justify-center gap-6 text-sm opacity-75">
            <span>✓ No credit cards</span>
            <span>✓ No spam</span>
            <span>✓ Just curiosity</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmailSignupSection;
